var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm2.96 4.954a1.159 1.159 0 110 2.317 1.159 1.159 0 010-2.317zm-5.92 0a1.16 1.16 0 110 2.318 1.16 1.16 0 010-2.318zm7.636 6.482c-1.558 1.347-3.187 1.78-4.638 1.78-2.604 0-4.64-1.398-4.67-1.418a.579.579 0 01.664-.948c.173.121 4.222 2.879 7.89-.289a.577.577 0 11.754.875z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmoji);
export default __webpack_public_path__ + "static/media/icon_emoji.53a6dfc371a26f6491581a51808e177f.svg";
export { ForwardRef as ReactComponent };